import { useState } from 'react';
import CtaPill from '../../../../../../common/_custom/CtaPill/CtaPill';
import { ctaPurpleRight } from '../../../../../../assets/hostedassets';
import { ESTABLISHMENTS_BUTTON_LABEL } from './constants';
import { useEpfFilingDetails } from './useEpfFilingDetails';
import EpfEstablishmentsDrawer from './EpfEstablishmentsDrawer';

/** "Details of Establishments (N)" — N counts every stored establishment, with or without payments. */
const EpfEstablishmentsButton = ({ graphData }: { graphData: any }) => {
    const { establishments } = useEpfFilingDetails(graphData, true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    if (!establishments.length) return null;
    return (
        <>
            <CtaPill
                size="small"
                label={`${ESTABLISHMENTS_BUTTON_LABEL} (${establishments.length})`}
                icon={ctaPurpleRight}
                onClick={() => setIsDrawerOpen(true)}
            />
            {isDrawerOpen && <EpfEstablishmentsDrawer establishments={establishments} onClose={() => setIsDrawerOpen(false)} />}
        </>
    );
};

export default EpfEstablishmentsButton;
